import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './assets/css/style.css'
import './assets/css/font.css'
import { BootstrapVue } from 'bootstrap-vue'
import VueImg from 'v-img';
import VueSweetalert2 from 'vue-sweetalert2';
import LoadingOverlay from 'vue-swal2-loading-overlay';

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'sweetalert2/dist/sweetalert2.min.css';

import vuetify from './plugins/vuetify'
Vue.use(BootstrapVue)
Vue.use(require('vue-moment'));
Vue.use(VueImg);
Vue.use(VueSweetalert2);
Vue.use(LoadingOverlay);

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
